var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.89543 20 2 20H13C14.1046 20 15 19.1046 15 18V5H10V0H2Z",
    fill: "#00733B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5L10 0V5H15Z",
    fill: "#4D9D76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28089 16.3008H5.18089L4.57589 15.2778L3.97089 16.3008H2.86539L4.02589 14.3373L2.90939 12.4508H4.01489L4.57589 13.4023L5.13689 12.4508H6.24239L5.12589 14.3428L6.28089 16.3008ZM7.59999 15.3493H8.92549V16.3008H6.61549V12.4508H7.59999V15.3493ZM10.6168 16.3833C10.2098 16.3833 9.87249 16.2971 9.60482 16.1248C9.33716 15.9524 9.15016 15.7196 9.04382 15.4263L9.88532 14.9368C10.0283 15.2778 10.2813 15.4483 10.6443 15.4483C10.945 15.4483 11.0953 15.3621 11.0953 15.1898C11.0953 15.0761 11.0092 14.9844 10.8368 14.9148C10.7635 14.8854 10.6022 14.8359 10.3528 14.7663C10.0008 14.6636 9.72216 14.5206 9.51682 14.3373C9.31149 14.1503 9.20882 13.8918 9.20882 13.5618C9.20882 13.2061 9.33532 12.9183 9.58832 12.6983C9.84499 12.4783 10.164 12.3683 10.5453 12.3683C10.868 12.3683 11.154 12.4434 11.4033 12.5938C11.6527 12.7441 11.8433 12.9623 11.9753 13.2483L11.1503 13.7323C11.0293 13.4463 10.8295 13.3033 10.5508 13.3033C10.4335 13.3033 10.3437 13.3271 10.2813 13.3748C10.2227 13.4224 10.1933 13.4829 10.1933 13.5563C10.1933 13.6406 10.2373 13.7121 10.3253 13.7708C10.417 13.8294 10.593 13.8973 10.8533 13.9743C11.0403 14.0293 11.1907 14.0806 11.3043 14.1283C11.418 14.1759 11.5427 14.2456 11.6783 14.3373C11.814 14.4253 11.9148 14.5408 11.9808 14.6838C12.0468 14.8231 12.0798 14.9881 12.0798 15.1788C12.0798 15.5564 11.946 15.8516 11.6783 16.0643C11.4107 16.2769 11.0568 16.3833 10.6168 16.3833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xlsIcon.4fc80bf4105f5a4d267b16b70a94f0ec.svg";
export { ForwardRef as ReactComponent };